var _path, _path2, _path3, _rect, _rect2, _path4, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDigitalWebDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,64A2.7528,2.7528,0,0,0,12,66.75H39.25v2.5H26v1.5H54v-1.5H40.75v-2.5H68A2.7528,2.7528,0,0,0,70.75,64V30A2.7528,2.7528,0,0,0,68,27.25H66v1.5h2A1.25116,1.25116,0,0,1,69.25,30V57.25H10.75V30A1.25116,1.25116,0,0,1,12,28.75h2v-1.5H12A2.7528,2.7528,0,0,0,9.25,30Zm1.5-5.25h58.5V64A1.25116,1.25116,0,0,1,68,65.25H12A1.25116,1.25116,0,0,1,10.75,64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.75,50V10A.7502.7502,0,0,0,62,9.25H18a.7502.7502,0,0,0-.75.75V50h1.5V10.75h42.5V50Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34,26.75a.7502.7502,0,0,0,.75-.75V16a.7502.7502,0,0,0-.75-.75H24a.7502.7502,0,0,0-.75.75V26a.7502.7502,0,0,0,.75.75Zm-9.25-10h8.5v8.5h-8.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 17.25,
    width: 16,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 23.25,
    width: 16,
    height: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46,42.75H56a.7502.7502,0,0,0,.75-.75V32a.7502.7502,0,0,0-.75-.75H46a.7502.7502,0,0,0-.75.75V42A.7502.7502,0,0,0,46,42.75Zm.75-10h8.5v8.5h-8.5Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 39.25,
    width: 16,
    height: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 33.25,
    width: 16,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigitalWebDesign);
export default __webpack_public_path__ + "static/media/icon_digital_web_design.605d4d2d8b21c613a9ee10929e885d18.svg";
export { ForwardRef as ReactComponent };